import { useEffect, useMemo, useState } from "react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { PackageCard } from "@/components/PackageCard";
import { fetchPackages } from "@/lib/api";

const GROUPS = [
  { key: "tutti", label: "Tutti" },
  { key: "tiktok", label: "TikTok" },
  { key: "instagram", label: "Instagram" },
  { key: "facebook", label: "Facebook" },
  { key: "advertising", label: "Advertising" },
];

export const Pacchetti = () => {
  const [packages, setPackages] = useState([]);
  const [group, setGroup] = useState("tutti");
  const [sort, setSort] = useState("default");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPackages()
      .then(setPackages)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const visible = useMemo(() => {
    let list = group === "tutti" ? [...packages] : packages.filter((p) => p.category_group === group);
    if (sort === "asc") list.sort((a, b) => a.price - b.price);
    if (sort === "desc") list.sort((a, b) => b.price - a.price);
    return list;
  }, [packages, group, sort]);

  return (
    <div className="pt-28 lg:pt-36">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>Catalogo 2025</Eyebrow>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white">
            Dieci pacchetti,
            <span className="text-gradient-blue"> zero sorprese.</span>
          </h1>
          <p className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-slate-400">
            Ogni pacchetto include riprese, montaggio e sottotitoli end-to-end,
            con formati verticali pronti da pubblicare o sponsorizzare.
            Prezzi netti, IVA calcolata allo checkout.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div data-testid="catalog-filter-group" className="flex flex-wrap gap-2">
            {GROUPS.map((g) => (
              <button
                key={g.key}
                data-testid={`catalog-filter-${g.key}`}
                onClick={() => setGroup(g.key)}
                className={`rounded-full border px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.2em] transition-all duration-300 ${
                  group === g.key
                    ? "border-electric bg-electric text-ink font-bold"
                    : "border-lineblue text-slate-300 hover:border-glow hover:text-electric"
                }`}
              >
                {g.label}
              </button>
            ))}
          </div>

          <select
            data-testid="catalog-sort"
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            className="rounded-full border border-lineblue bg-surface px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-300 outline-none focus:border-electric"
          >
            <option value="default">Ordina: consigliati</option>
            <option value="asc">Prezzo crescente</option>
            <option value="desc">Prezzo decrescente</option>
          </select>
        </Reveal>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-28 pt-10">
        {loading ? (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="h-[420px] animate-pulse rounded-2xl border border-lineblue bg-panel" />
            ))}
          </div>
        ) : (
          <div data-testid="catalog-grid" className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {visible.map((p, i) => (
              <PackageCard key={p.slug} pkg={p} index={i} />
            ))}
          </div>
        )}

        {!loading && visible.length === 0 && (
          <p className="py-20 text-center text-slate-400">
            Nessun pacchetto in questa categoria.
          </p>
        )}
      </div>
    </div>
  );
};

export default Pacchetti;
